import React, { useState } from 'react';
import { Link, useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import Dropdown from "react-bootstrap/Dropdown";
import HelpIcon from "../../../images/icon_help.gif";
import PearsonLogo from '../../../images/pearson_logo.png';
import apiService from "../../utils/apiService";
import tokenRefreshService from "../../utils/tokenRefreshService";
import {
  buildHelpBackPath,
  buildHelpPath,
} from "../../utils/pathUtils";

const TopNav = (props) => {
    const { instance, accounts } = useMsal();
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const helpPath = buildHelpPath(location.pathname);
    const backButtonLocationPath = buildHelpBackPath(location.pathname);

    const [showDropdownItems, setShowDropdownItems] = useState(false);
    
    // Security Fix: Enhanced logout to clear application browser storage
    // Reference: WSTG-ATHN-06 - Browser Cache Weakness
    // Note: We clear app-specific data here; full storage clear happens on Login page mount
    // 
    // Also revokes all refresh tokens via Microsoft Graph API to prevent new access tokens
    // from being issued after logout. Access tokens are stateless and cannot be revoked,
    // but they expire in ~1 hour.
    const handleLogout = async (logoutType) => {
        if (logoutType === "redirect") {
            // Step 1: Stop token refresh service
            console.log('Stopping token refresh service before logout...');
            tokenRefreshService.stopTokenRefresh();

            // Step 2: Revoke all refresh tokens via Microsoft Graph API
            // This ensures no new access tokens can be issued after logout
            try {
                console.log('Revoking sign-in sessions before logout...');
                await apiService.revokeSignInSessions();
            } catch (error) {
                // Log but don't block logout - proceed even if revocation fails
                console.error('Failed to revoke sign-in sessions:', error);
            }

            // Step 3: Clear all localStorage and sessionStorage including OID and related items
            // Clear all application data including custom token and user data
            // NOTE: accessToken contains CUSTOM token (not Azure token)
            const appKeys = [
                'directories', 
                'directoriesListDelete', 
                'accessToken',  // Custom token (not Azure token)
                'clientId', 
                'user.role',
                'userOid',      // User Object ID
                'userTid'       // Tenant ID
            ];
            appKeys.forEach(key => localStorage.removeItem(key));
            
            // Clear all localStorage (ensures everything is removed)
            localStorage.clear();
            
            // Clear all sessionStorage
            sessionStorage.clear();
            
            // Set a flag indicating logout was initiated (Login page will do full cleanup)
            sessionStorage.setItem('logoutInitiated', 'true');
            
            console.log('Application storage cleared, redirecting to Azure logout');
            
            // Step 4: Redirect to Azure AD logout - MSAL will handle its own token cleanup
            instance.logoutRedirect({
                postLogoutRedirectUri: "/",
            });
        }
    };
    // End Security Fix
    const toggleDropdown = () => {
        setShowDropdownItems(!showDropdownItems);
    };
    
    // Get user name from MSAL account (for display only)
    // NOTE: This reads from MSAL's internal cache - MSAL manages this storage
    // We use MSAL's account object which is the recommended approach
    const activeAccount = accounts[0];
    let userName = '';
    
    // Preferred: Get from MSAL account object (recommended approach)
    if (activeAccount?.idTokenClaims?.name) {
        userName = activeAccount.idTokenClaims.name;
    } else {
        // Fallback: Read from MSAL's internal localStorage cache
        // This is MSAL's own storage, not our custom storage
        // MSAL stores tokens with pattern: `${homeAccountId}-${environment}-idtoken-${clientId}-${tenantId}--`
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (/^.+-login\.windows\.net-\d.+$/.test(key)) {
                try {
                    const tokenlist = localStorage.getItem(key);
                    const tokenvalue = JSON.parse(tokenlist);
                    userName = tokenvalue.idTokenClaims?.name || '';
                    break;
                } catch (e) {
                    // Continue searching if parsing fails
                    console.warn('Failed to parse MSAL token cache:', e);
                }
            }
        }
    }

    return (
        <>
            <table border="0" width="99%" cellSpacing="3" cellPadding="0" role="presentation">
                <tr align="left" valign="top">
                    <td align="left" valign="middle"><span className="pagetitle">{props.title}</span></td>
                    <td align="right" valign="middle">

                        <table border="0" cellSpacing="0" cellPadding="0" align="right" role="presentation">
                            <tr align="left" valign="top">
                                {searchParams.get("help") == 1 &&
                                    <td align="right" valign="middle" nowrap><Link to={backButtonLocationPath}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            navigate(backButtonLocationPath);
                                        }}
                                        class="helpLink" title="back">back</Link>&nbsp;</td>
                                }
                                {searchParams.get("help") != 1 &&
                                    <td align="right " valign="middle" nowrap="true"><Link to={helpPath} onClick={(e) => {
                                        e.preventDefault();
                                        navigate(helpPath);
                                    }} className="helpLink" title="Need Help?">Need Help</Link>&nbsp;</td>
                                }
                                <td align="left" valign="middle"><Link to="?help=1" title="Need Help?"><img src={HelpIcon} alt="Need Help?" title="Need Help?" width="25" height="25" hspace="4" vspace="0" border="0" /></Link></td>
                            </tr>
                        </table>

                    </td>
                    <td align="right" className="logout-td" valign="middle" width="5%">
                        <Dropdown>
                            <Dropdown.Toggle as={Dropdown.Text} variant="secondary" className="drop-down" drop="start" onClick={toggleDropdown}>
                                {userName}
                            </Dropdown.Toggle>
                            {showDropdownItems && (
                                <Dropdown.Menu
                                    show
                                    
                                    className="drop-item-logout"
                                >
                                    <Dropdown.Item
                                        as="button"
                                        className="drop-item-logout"
                                        onClick={() => handleLogout("redirect")}
                                    >
                                        Logout
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            )}

                        </Dropdown>

                    </td>
            
                    <td align="right" valign="middle" width="6%" style={{ paddingLeft: "10px" }}><img src={PearsonLogo} title="Pearson Education" alt="Pearson Education" width="80" height="25" hspace="0" vspace="0" border="0" /></td>
                </tr>
            </table>


        </>
    )
}

export default TopNav;